import React from 'react';
import {Styles} from '../../../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import axios from "axios";
import {defaultVariabls} from "../../../../../../config/index";
import {withRouter} from "react-router-dom";
import { withSnackbar } from 'notistack';
import {setStore} from "trim-redux";
import ChipInput from "material-ui-chip-input";
import InputAdornment from "@material-ui/core/InputAdornment/InputAdornment";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import {Translate} from "../../../../../../config/Translate";

class CoverTypesField extends React.Component {
    state = {
        items:[],
        loading:true,
        SubmitLoading:false,
    };
    classes = this.props.classes;

    componentDidMount(){
        this.loadData();
    }

    async loadData(){
        let loginToken = localStorage.getItem('ACT');
        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.get(`${defaultVariabls.url}/covers/getAll`, config)
                .then(async response => {
                    let items = [];
                    await response.data.map((item) => {
                        items.push(item.description)
                    })
                    await this.setState({
                        items,
                        loading:false
                    })
                })
                .catch(error => {
                    console.log(error.response)
                    this.setState({
                        loading:false
                    })
                })
        }else {
            setStore({
                isAuth : false,
                user : null,
            });
            this.setState({
                loading:false
            })
        }
    }
    async handleAddChip(item){
        let {items} = this.state;
        items.push(item);
        this.setState({
            loading:true,
            items
        })
        let data = new FormData();
        data.append('new', item);
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariabls.url}/cover/make`, data, config)
            .then(async response => {
                this.loadData();
            })
            .catch(error => {
                console.log(error.response)
                this.props.enqueueSnackbar(Translate.allChangesSavingFailed, {
                    variant: 'error',
                });
                this.loadData();
            });
    }
    async handleDeleteChip(chip, index){
        this.setState({
            loading:true
        })
        let data = new FormData();
        data.append('item', chip);
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariabls.url}/cover/delete`, data, config)
            .then(async response => {
                this.loadData();
            })
            .catch(error => {
                console.log(error.response)
                this.props.enqueueSnackbar(Translate.allChangesSavingFailed, {
                    variant: 'error',
                });
                this.loadData();
            });
    }
    render(){
        let {loading,items} = this.state;
        return (
            <React.Fragment>
                <ChipInput
                    value={items}
                    fullWidth
                    label={Translate.cover_types}
                    variant={"outlined"}
                    onAdd={(chip) => this.handleAddChip(chip)}
                    onDelete={(chip, index) => this.handleDeleteChip(chip, index)}
                    InputProps={loading && {
                        endAdornment: (
                            <InputAdornment position="end">
                                <CircularProgress size={22}/>
                            </InputAdornment>
                        ),
                    }}

                />
            </React.Fragment>

        );
    }
}

export default withSnackbar(withRouter(withStyles(Styles)(CoverTypesField)));